const CONFIG = {
    API_BASE_URL: "https://main-inbound-automation.vercel.app/api/contact",
    BRAND: "naar",
    BRAND_NAME: "NAAR",
};

const countryNameToIso2 = {};

function buildCountryNameMap() {
    if (typeof intlTelInput === 'undefined') return;
    const countryData = intlTelInput.getCountryData ? intlTelInput.getCountryData() :
                        (window.intlTelInputGlobals ? window.intlTelInputGlobals.getCountryData() : []);
    countryData.forEach((c) => {
        const cleanName = c.name.replace(/\s*\(.*\)/, '').trim().toLowerCase();
        countryNameToIso2[cleanName] = c.iso2;
        countryNameToIso2[c.name.toLowerCase()] = c.iso2;
    });
    Object.assign(countryNameToIso2, {
        'bolivia': 'bo', 'brunei': 'bn', 'congo': 'cg',
        'democratic republic of the congo': 'cd', 'falkland islands': 'fk',
        'iran': 'ir', 'ivory coast': 'ci', "cote d'ivoire": 'ci',
        'north korea': 'kp', 'south korea': 'kr', 'laos': 'la',
        'libya': 'ly', 'macedonia': 'mk', 'macedonia (fyrom)': 'mk',
        'micronesia': 'fm', 'moldova': 'md', 'palestine': 'ps',
        'russia': 'ru', 'saint helena': 'sh', 'syria': 'sy',
        'taiwan': 'tw', 'tanzania': 'tz', 'venezuela': 've',
        'vietnam': 'vn', 'british virgin islands': 'vg',
        'u.s. virgin islands': 'vi', 'myanmar (burma)': 'mm',
        'türkiye': 'tr', 'east timor': 'tl', 'vatican city': 'va',
        'kosovo': 'xk', 'swaziland': 'sz', 'cape verde': 'cv',
    });
}

function getIso2FromCountryName(name) {
    if (!name) return '';
    const lower = name.toLowerCase().trim();
    if (countryNameToIso2[lower]) return countryNameToIso2[lower];
    const keys = Object.keys(countryNameToIso2);
    for (let i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(lower) !== -1 || lower.indexOf(keys[i]) !== -1) {
            return countryNameToIso2[keys[i]];
        }
    }
    return '';
}

const PopupManager = {
    state: { userType: null },
    itiInstance: null,

    $(id) {
        return document.getElementById(id);
    },

    capitalize(str) {
        if (!str) return "";
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    },

    show(element) {
        if (typeof element === "string") element = this.$(element);
        if (element) element.style.display = "block";
    },

    hide(element) {
        if (typeof element === "string") element = this.$(element);
        if (element) element.style.display = "none";
    },

    showView(viewToShow) {
        this.hide("naar-popup-user-type-view");
        this.hide("naar-popup-form-view");
        this.hide("naar-popup-success-view");
        this.hide("naar-popup-business-success-view");
        this.show(viewToShow);
    },

    setFormFieldsDisabled(disabled) {
        const fields = ["popupFirstName", "popupLastName", "popupEmail", "popupPhone", "popupCountry", "naar-popup-back-btn"];
        fields.forEach((id) => {
            const field = this.$(id);
            if (field) field.disabled = disabled;
        });

        const radioButtons = document.querySelectorAll('input[name="user_type"]');
        radioButtons.forEach((radio) => (radio.disabled = disabled));

        const form = this.$("naar-popup-form");
        const submitButton = form?.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = disabled;

        if (form) {
            form.style.opacity = disabled ? "0.6" : "1";
            form.style.pointerEvents = disabled ? "none" : "auto";
        }
    },

    init() {
        this.loadCountries();
        this.setupEventListeners();
        this.setupNameCapitalization();
        this.showPopup();
    },

    async loadCountries() {
        const countrySelect = this.$("popupCountry");
        if (!countrySelect) return;

        const countries = [
        "Afghanistan",
        "Albania",
        "Antarctica",
        "Åland Islands",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua and Barbuda",
        "Aruba",
        "Asia/Pacific Region",
        "Azerbaijan",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belgium",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "Caribbean Netherlands",
        "Belize",
        "Solomon Islands",
        "Brunei",
        "Bulgaria",
        "Burundi",
        "Belarus",
        "Bermuda",
        "Cambodia",
        "Cayman Islands",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Central African Republic",
        "Cuba",
        "Curaçao",
        "Sri Lanka",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Democratic Republic of the Congo",
        "Cook Islands",
        "Costa Rica",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Benin",
        "Denmark",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "El Salvador",
        "Equatorial Guinea",
        "Ethiopia",
        "Eritrea",
        "Estonia",
        "Europe",
        "South Georgia and the South Sandwich Islands",
        "Fiji",
        "Finland",
        "France",
        "Falkland Islands",
        "Faroe Islands",
        "French Polynesia",
        "French Southern and Antarctic Lands",
        "Djibouti",
        "Gabon",
        "Georgia",
        "Gambia",
        "Germany",
        "Ghana",
        "Greenland",
        "Guadeloupe",
        "Guernsey",
        "Kiribati",
        "Greece",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guyana",
        "French Guiana",
        "Gibraltar",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Vatican City",
        "Honduras",
        "Hungary",
        "Hong Kong",
        "Isle of Man",
        "Iran",
        "Jersey",
        "Macau",
        "Martinique",
        "Montserrat",
        "Myanmar (Burma)",
        "North Korea",
        "Palestine",
        "Puerto Rico",
        "Réunion",
        "Saint Barthélemy",
        "Saint Martin",
        "Sint Maarten",
        "South Sudan",
        "Sudan",
        "Syria",
        "Taiwan",
        "Turks and Caicos Islands",
        "U.S. Virgin Islands",
        "Iceland",
        "India",
        "Indonesia",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "British Indian Ocean Territory",
        "Cote d'Ivoire",
        "Jamaica",
        "Japan",
        "Kazakhstan",
        "Jordan",
        "Kenya",
        "South Korea",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Lebanon",
        "Lesotho",
        "Latvia",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Monaco",
        "Mongolia",
        "Moldova",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Oman",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "Vanuatu",
        "Netherlands Antilles",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Norway",
        "Northern Mariana Islands",
        "United States Minor Outlying Islands",
        "Micronesia",
        "Marshall Islands",
        "Palau",
        "Pakistan",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Islands",
        "Poland",
        "Portugal",
        "Guinea-Bissau",
        "East Timor",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Svalbard and Jan Mayen",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Vietnam",
        "Western Sahara",
        "Slovenia",
        "Somalia",
        "South Africa",
        "Zimbabwe",
        "Spain",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Tajikistan",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "United Arab Emirates",
        "Tunisia",
        "Türkiye",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "Macedonia (FYROM)",
        "Egypt",
        "United Kingdom",
        "Tanzania",
        "United States",
        "Burkina Faso",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "British Virgin Islands",
        "Wallis and Futuna",
        "Samoa",
        "Yemen",
        "Zambia",
        "Canary Islands"
        ];

        countries.sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: "base" })
        );

        countries.forEach((country) => {
            const option = document.createElement("option");
            option.value = country;
            option.textContent = country;
            countrySelect.appendChild(option);
        });

        this.initIntlTelInput();
    },

    initIntlTelInput() {
        if (typeof intlTelInput === 'undefined') return;
        buildCountryNameMap();

        const phoneInput = this.$('popupPhone');
        if (!phoneInput) return;

        this.itiInstance = intlTelInput(phoneInput, {
            initialCountry: 'auto',
            geoIpLookup: (successCallback) => {
                fetch('https://ipapi.co/json/')
                    .then((resp) => resp.json())
                    .then((data) => successCallback((data && data.country) ? data.country : 'us'))
                    .catch(() => successCallback('us'));
            },
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js',
            nationalMode: true,
            formatOnDisplay: true,
            autoPlaceholder: 'aggressive',
        });

        // Capture wheel events on the country list before anything else can
        // handle them. Manually scroll the list, block everything else.
        document.addEventListener('wheel', function(e) {
            var list = e.target.closest('.iti__country-list');
            if (!list) return;
            list.scrollTop += e.deltaY;
            e.preventDefault();
            e.stopPropagation();
        }, { passive: false, capture: true });

        // Phone flag → Country dropdown sync
        phoneInput.addEventListener('countrychange', () => {
            const selectedData = this.itiInstance.getSelectedCountryData();
            if (!selectedData || !selectedData.iso2) return;
            const countrySelect = this.$('popupCountry');
            if (!countrySelect) return;
            for (let i = 0; i < countrySelect.options.length; i++) {
                if (getIso2FromCountryName(countrySelect.options[i].value) === selectedData.iso2) {
                    countrySelect.value = countrySelect.options[i].value;
                    break;
                }
            }
        });

        // Country dropdown → Phone flag sync
        const countrySelect = this.$('popupCountry');
        if (countrySelect) {
            countrySelect.addEventListener('change', () => {
                const iso2 = getIso2FromCountryName(countrySelect.value);
                if (iso2 && this.itiInstance) {
                    this.itiInstance.setCountry(iso2);
                }
            });
        }

        // Real-time phone validation
        phoneInput.addEventListener('blur', () => this.validatePhoneField());
        phoneInput.addEventListener('input', () => {
            if (phoneInput.classList.contains('is-invalid')) this.validatePhoneField();
        });
    },

    validatePhoneField() {
        const phoneInput = this.$('popupPhone');
        const phoneError = phoneInput?.parentElement?.querySelector('.popup-phone-error');
        const value = phoneInput?.value?.trim();

        if (!value) {
            phoneInput.classList.add('is-invalid');
            if (phoneError) { phoneError.textContent = 'This field is required'; phoneError.style.display = 'block'; }
            return false;
        }

        if (this.itiInstance && !this.itiInstance.isValidNumber()) {
            phoneInput.classList.add('is-invalid');
            if (phoneError) { phoneError.textContent = 'Please enter a valid phone number'; phoneError.style.display = 'block'; }
            return false;
        }

        phoneInput.classList.remove('is-invalid');
        if (phoneError) phoneError.style.display = 'none';
        return true;
    },

    setupNameCapitalization() {
        const firstNameInput = this.$("popupFirstName");
        const lastNameInput = this.$("popupLastName");

        if (firstNameInput) {
            firstNameInput.addEventListener("input", () => {
                const start = firstNameInput.selectionStart;
                const end = firstNameInput.selectionEnd;
                firstNameInput.value = this.capitalize(firstNameInput.value);
                firstNameInput.setSelectionRange(start, end);
            });
        }

        if (lastNameInput) {
            lastNameInput.addEventListener("input", () => {
                const start = lastNameInput.selectionStart;
                const end = lastNameInput.selectionEnd;
                lastNameInput.value = this.capitalize(lastNameInput.value);
                lastNameInput.setSelectionRange(start, end);
            });
        }
    },

    setupEventListeners() {
        const closeButton = this.$("naar-popup-close");
        const nextButton = this.$("naar-popup-next-btn");
        const backButton = this.$("naar-popup-back-btn");
        const businessSuccessCloseButton = this.$("naar-business-success-close-btn");
        const popupForm = this.$("naar-popup-form");
        const popupOverlay = this.$("naar-popup-overlay");

        if (closeButton) closeButton.addEventListener("click", () => this.hidePopup());
        if (businessSuccessCloseButton) businessSuccessCloseButton.addEventListener("click", () => this.hidePopup());
        if (popupOverlay) {
            popupOverlay.addEventListener("click", (event) => {
                if (event.target === popupOverlay) this.hidePopup();
            });
        }

        if (nextButton) {
            nextButton.addEventListener("click", () => {
                const checkedRadio = document.querySelector('input[name="user_type"]:checked');
                if (checkedRadio) {
                    this.state.userType = checkedRadio.value;
                    this.hide("naar-user-type-error");
                    this.updateFormText();
                    this.showView("naar-popup-form-view");
                } else {
                    this.show("naar-user-type-error");
                }
            });
        }

        document.querySelectorAll('input[name="user_type"]').forEach((radio) => {
            radio.addEventListener("change", () => {
                this.state.userType = radio.value;
                this.hide("naar-user-type-error");
                this.updateFormText();
                this.showView("naar-popup-form-view");
            });
        });

        if (backButton) backButton.addEventListener("click", () => this.showView("naar-popup-user-type-view"));

        if (popupForm) {
            popupForm.addEventListener("submit", (event) => this.handleSubmit(event));
        }
    },

    updateFormText() {
        const consumerFormText = this.$("naar-popup-form-text-consumer");
        const businessFormText = this.$("naar-popup-form-text-business");

        if (this.state.userType === "Consumer") {
            this.show(consumerFormText);
            this.hide(businessFormText);
        } else {
            this.hide(consumerFormText);
            this.show(businessFormText);
        }
    },

    showPopup() {
        const popupOverlay = this.$("naar-popup-overlay");
        if (popupOverlay) {
            setTimeout(() => {
                popupOverlay.style.display = "flex";
            }, 100);
        }
    },

    hidePopup() {
        const popupOverlay = this.$("naar-popup-overlay");
        if (popupOverlay) popupOverlay.style.display = "none";
    },

    async handleSubmit(event) {
        event.preventDefault();

        // Validate phone before submission
        if (!this.validatePhoneField()) return;

        const submitButton = this.$("naar-popup-form").querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;
        const errorHolder = this.$("naar-popup-error");

        this.setFormFieldsDisabled(true);
        submitButton.textContent = "Processing...";
        this.hide(errorHolder);

        const phoneInput = this.$("popupPhone");
        const phoneNumber = this.itiInstance ? this.itiInstance.getNumber() : phoneInput.value;

        const formData = {
            action: "popup",
            brand: CONFIG.BRAND,
            type: this.state.userType,
            firstName: this.$("popupFirstName").value,
            lastName: this.$("popupLastName").value,
            email: this.$("popupEmail").value,
            phone: phoneNumber,
            country: this.$("popupCountry").value,
        };

        try {
            const response = await fetch(CONFIG.API_BASE_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "An unexpected error occurred.");
            }

            if (result.coupon_code) {
                const couponCodeHolder = this.$("naar-coupon-code-display");
                if (couponCodeHolder) couponCodeHolder.textContent = result.coupon_code;
                this.showView("naar-popup-success-view");
            } else {
                this.showView("naar-popup-business-success-view");
            }
        } catch (error) {
            if (errorHolder) {
                errorHolder.textContent = error.message;
                this.show(errorHolder);
            }
        } finally {
            this.setFormFieldsDisabled(false);
            submitButton.textContent = originalButtonText;
        }
    },
};

document.addEventListener("DOMContentLoaded", function () {
    PopupManager.init();
});
